/** @format — Empty state when search returns no documents */

import { Search } from "lucide-react";

export default function DocumentsSearchEmptyState({ query }: { query: string }) {
  const trimmed = query.trim();

  return (
    <div className="flex w-full flex-col items-center px-4 pt-16 md:px-5 md:pt-24 lg:px-8">
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-neutral-100 p-2">
        <Search className="h-6 w-6 text-[#0A0A0A]" strokeWidth={2} />
      </div>
      <div className="mt-4 flex max-w-2xl flex-col items-center gap-2">
        <p className="text-center text-base font-medium text-[#11121a]">
          No documents matching &ldquo;{trimmed}&rdquo;
        </p>
        <p className="text-center text-xs text-neutral-500">
          Try a different keyword or check your spelling.
        </p>
      </div>
    </div>
  );
}
